import $ from 'jquery'
import 'selectize/dist/js/selectize.min'

document.addEventListener('turbo:load', function() {
    $('[data-behavior~="selectize-input"] select').selectize({
        sortField: 'text'
    })
})
